import { useState } from 'react'
import { HStack, Text, IconButton, Box, Field } from '@chakra-ui/react';
import { FiEdit2, FiX } from 'react-icons/fi'
import { ContactSearchSelect } from './ContactSearchSelect'

interface InlineContactSelectProps {
  label: string
  contactId?: string
  contactName?: string
  fieldName: string
  canEdit: boolean
  onSave: (fieldName: string, contactId: string | null, name?: string | null) => void
  isSaving?: boolean
  allowFreeText?: boolean
}

export function InlineContactSelect({
  label,
  contactId,
  contactName,
  fieldName,
  canEdit,
  onSave,
  allowFreeText = false,
}: InlineContactSelectProps) {
  const [isEditing, setIsEditing] = useState(false)

  const handleSelect = (newContactId: string | null, name: string | null) => {
    onSave(fieldName, newContactId, name)
    setIsEditing(false)
  }

  const handleCancel = () => {
    setIsEditing(false)
  }

  if (isEditing) {
    return (
      <Field.Root>
        <Field.Label fontSize="xs" color="gray.500" mb={1}>{label}</Field.Label>
        <HStack>
          <Box flex={1}>
            <ContactSearchSelect
              value={contactId}
              displayName={contactName}
              onSelect={handleSelect}
              placeholder={`Search for ${label.toLowerCase()}...`}
              allowFreeText={allowFreeText}
            />
          </Box>
          <IconButton aria-label="Cancel" size="sm" variant="ghost" onClick={handleCancel}><FiX /></IconButton>
        </HStack>
      </Field.Root>
    );
  }

  return (
    <Field.Root>
      <Field.Label fontSize="xs" color="gray.500" mb={1}>{label}</Field.Label>
      <HStack gap={1}>
        <Text fontSize="sm">{contactName || '—'}</Text>
        {canEdit && (
          <IconButton
            aria-label={`Edit ${label}`}
            size="xs"
            variant="ghost"
            color="gray.400"
            onClick={() => setIsEditing(true)}><FiEdit2 /></IconButton>
        )}
      </HStack>
    </Field.Root>
  );
}
